import { useDispatch, useSelector } from 'react-redux';
import type { HTTPError } from 'services/api/entities';
import {
  checkLoadingSelector,
  checkErrorSelector,
} from 'services/store/base/selectors';
import {
  loginWithFacebook,
  authActionNames,
} from 'services/store/auth/actions';
import type { BaseActionStore, StoreRootState } from 'services/store/types';
import type { Nullable } from 'types';

type UseFacebookLogin = {
  loading: boolean;
  error: Nullable<HTTPError>;
  loginWithFacebook: (token: string) => void;
};

const useFacebookLogin = (): UseFacebookLogin => {
  const dispatch = useDispatch();
  const baseStore: BaseActionStore = useSelector(
    (store: StoreRootState) => store.base
  );

  return {
    loading: checkLoadingSelector(baseStore, [
      authActionNames.LOGIN_WITH_FACEBOOK,
    ]),
    error: checkErrorSelector(baseStore, [
      authActionNames.LOGIN_WITH_FACEBOOK,
      authActionNames.LOGIN_TO_APP,
    ]),
    loginWithFacebook: (token: string): void => {
      dispatch(loginWithFacebook(token));
    },
  };
};

export default useFacebookLogin;
